<template>
  <div>
    <div class="flex flex-col p-10 text-center items-center">
      <h3 class="font-bold text-orange-academy-300 py-4">
           {{ $t('newTimezone.title') }}</h3>
      <h5 class="text-orange-academy-300">{{ $t('newTimezone.question') }}</h5>
      <custom-general-select :options="timezonesArray" v-model="selectedTimezone" />

      <div class="flex flex-row w-1/2 mx-auto">
        <button
          @click="saveTimezone"
          class="px-4 py-3 rounded border bg-orange-academy-300 border-orange-academy-300
          hover:bg-white text-white hover:text-orange-academy-300 font-bold cursor-pointer mb-3 p-2
           mt-10 mx-auto">
            {{ $t('newTimezone.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CustomGeneralSelect from '@/components/CustomGeneralSelect.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import dayjs from 'dayjs';

export default {
  props: {
    timezonesArray: Array,
  },

  data() {
    return {
      selectedTimezone: '',
    };
  },

  created() {
    this.selectedTimezone = dayjs.tz.guess();
  },

  components: {
    CustomGeneralSelect,
  },

  computed: {
    ...mapGetters({
      localTimezone: 'timezone/localTimezone',
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    ...mapActions({
      setChoosenTimezone: 'timezone/setChoosenTimezone',
      setLastChoosenTimezone: 'timezone/setLastChoosenTimezone',
    }),

    saveTimezone() {
      this.setChoosenTimezone(this.selectedTimezone);
      dayjs.tz.setDefault(this.choosenTimezone);
      this.setLastChoosenTimezone(this.user.id);
      this.$emit('close');
    },

  },

};
</script>
